import React from 'react';
import { Icon, Input } from 'semantic-ui-react';
import { Restricted } from 'dyl-components';
import { USER_PERMISSIONS } from 'dyl-components';
import './index.scss';

const Editable = ({
    value,
    isReadLoading = false,
    isEditing,
    onEdit,
    children,
    submitDisabled,
    onConfirmEdit,
    onCancelEdit,

    size,
    underline,
    recordType,
    assignees,
}) => (
    !isEditing ? <Input {...size ? { size } : {}} value={value} readOnly className={`Editable${underline ? ' Editable--underlined' : ''}`} onClick={onEdit} loading={isReadLoading} /> : (
        <React.Fragment>
            {children}
            <Icon style={{ marginLeft: '1em', display: 'inline-block' }} {...size ? { size } : {}} className='fas fa-times' color='red' link onClick={onCancelEdit} />
            <Restricted type="disabled" userPermission={
                recordType === "master_account" ? USER_PERMISSIONS.MASTER_ACCOUNT_EDIT 
                    : recordType === "account" || recordType === "customer" ? USER_PERMISSIONS.ACCOUNT_EDIT 
                        : recordType === "opportunity" ? USER_PERMISSIONS.OPPORTUNITY_EDIT 
                            : recordType === "lead" ? USER_PERMISSIONS.LEAD_EDIT
                                : USER_PERMISSIONS.CONTACTS_EDIT
                } 
                userRestrict={recordType !== "master_account"} 
                assignmentIds={recordType !== "master_account" ? [(assignees?.["owner_id"] || 0), (assignees?.["coowner_id"] || 0)] : null} 
            >
                <Icon
                    {...size ? { size } : {}}
                    style={{ display: 'inline-block' }}
                    disabled={submitDisabled}
                    className='fas fa-check'
                    color='blue'
                    link
                    onClick={onConfirmEdit}
                />
            </Restricted>
        </React.Fragment>
    )
);

export default Editable;
